// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__NAOAl","modal":"Modal_modal__sk9lV","fecharModal":"Modal_fecharModal__jKMvN"};